import React from 'react';
import { Box, Dialog, Grid, Typography } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import { CustomButton, CustomDialogAction, CustomDialogContent, CustomDialogTitle, CustomInputLabel, StyledCard } from '../../../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import importStyles from './servicecatalog.module.css';

const TimingModal = (props) => {
  return (
    <div>
      <Dialog
        aria-labelledby='form-dialog-title'
        open={props.modal == 'timing'}
        onClose={props.onClose}
        maxWidth={'lg'}
        fullWidth
        scroll='paper'>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Office Hours
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <div className={`${styles.textCenter}`}>
            <Typography variant='body1' color='primary' component='div' display='inline-block' fontWeight={600} fontSize={18} textAlign='center' mb={4} borderBottom='2px solid var(--secondarygreen)'>
                Set Office Hours
            </Typography>
          </div>
          <StyledCard className={importStyles.timingModalCard}>
            <Grid container spacing={4}>
              <Grid item container spacing={{
                xs: 2,
                md: 4,
                lg: 6
              }} rowSpacing={{
                xs: 2,
                md: 4,
                lg: 4 
              }} xs={12}>
                {props.timings && props.timings.map((time, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={12}  md={6} lg={4}>
                      <Box className={importStyles.dayCard}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Typography variant='body2' color='white' textTransform='uppercase' fontWeight={700} fontSize={14}
                              className={importStyles.dayCardTitle}>
                              {time.day}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <CustomInputLabel htmlFor='open'>Open</CustomInputLabel>
                            <input
                              id='open'
                              label='Open'
                              name='open'
                              type='time'
                              defaultValue={time.open}
                              onChange={(e) => props.handleTimeChange(e, time.id, 'open')}
                              className={`${styles.ipTimePicker} ${styles.w100}`}
                            />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <CustomInputLabel htmlFor='close'>Close</CustomInputLabel>
                            <input
                              id='close'
                              label='Close'
                              name='close'
                              type='time'
                              defaultValue={time.close}
                              onChange={(e) => props.handleTimeChange(e, time.id, 'close')}
                              className={`${styles.ipTimePicker} ${styles.w100}`}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Grid>
          </StyledCard>
        </CustomDialogContent>
        <CustomDialogAction className={importStyles.timingModalAction}>
          <CustomButton variant='contained' type='reset' onClick={props.onClose} className={importStyles.actionButton}> Close</CustomButton>
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};
export default TimingModal;